/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListProductTagsResponseFromDiscriminatorValue, createUpdateProductTagsResponseFromDiscriminatorValue, serializeUpdateProductTagsRequest, serializeUpdateProductTagsResponse, type ErrorResponse, type InternalErrorResponse, type ListProductTagsResponse, type UpdateProductTagsRequest, type UpdateProductTagsResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products/tags
 */
export interface TagsRequestBuilder extends BaseRequestBuilder<TagsRequestBuilder> {
    /**
     * Lists the organization's distinct product tags, each with the number of products carrying it, ordered by tag. Tags are returned in their stored normalized (UPPERCASE) form. An organization with no tagged products gets an empty list.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListProductTagsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListProductTagsResponse | undefined>;
    /**
     * Replaces the tags for the listed SKUs (declarative replace-per-SKU: an empty Tags array clears a product's tags; SKUs absent from the request are untouched). Repeated SKUs are unioned. Unknown SKUs are skipped and reported in the response, never failing the batch. For an agency organization a row's vendorCode names the line the product belongs to and the row's SKU is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone, so an exported sheet re-imports unchanged; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any write otherwise. A row without a vendorCode uses its SKU exactly as given. The applied and skipped lists name the stored SKUs.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<UpdateProductTagsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateProductTagsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<UpdateProductTagsResponse | undefined>;
    /**
     * Lists the organization's distinct product tags, each with the number of products carrying it, ordered by tag. Tags are returned in their stored normalized (UPPERCASE) form. An organization with no tagged products gets an empty list.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Replaces the tags for the listed SKUs (declarative replace-per-SKU: an empty Tags array clears a product's tags; SKUs absent from the request are untouched). Repeated SKUs are unioned. Unknown SKUs are skipped and reported in the response, never failing the batch. For an agency organization a row's vendorCode names the line the product belongs to and the row's SKU is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone, so an exported sheet re-imports unchanged; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any write otherwise. A row without a vendorCode uses its SKU exactly as given. The applied and skipped lists name the stored SKUs.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateProductTagsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TagsRequestBuilderUriTemplate = "{+baseurl}/api/products/tags";
/**
 * Metadata for all the requests in the request builder.
 */
export const TagsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TagsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListProductTagsResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: TagsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createUpdateProductTagsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateProductTagsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
